export const setUserProfile = (data) => ({
    type: 'SET_USER_PROFILE',
    payload: data,
  });